import InternalImageLink from './Still_Internal';

export default InternalImageLink;
